import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_CLIENT_PRICE, GET_CLIENT_PRICE_SUCCESS, GET_CLIENT_PRICE_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getClientPrice({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/client-price-details`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': 'ADMIN_ACCESS',
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CLIENT_PRICE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CLIENT_PRICE_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CLIENT_PRICE_ERROR, payload: error });
  }
}

export function* watchGetClientPrice() {
  yield takeEvery(GET_CLIENT_PRICE, getClientPrice);
}

function* getClientPriceSaga() {
  yield all([fork(watchGetClientPrice)]);
}

export default getClientPriceSaga;
